import React, {useEffect, useRef} from "react";
import {
    XBrowseProps,
    XFilterElementParams,
    XLazyColumn,
    XLazyDataTable, XLazyDataTableRef,
    XMultilineRenderType,
    XSearchBrowseProps
} from "@michalrakus/x-react-web-lib/XLazyDataTable";
import {Utils} from "../../Utils";
import {KlientSluzbaColumnFilter} from "./KlientSluzbaColumnFilter";
import {xLocaleOption} from "@michalrakus/x-react-web-lib/XLocale";
import {SluzbaEnum, StatusVSluzbe} from "../../common/enums";
import {XCustomFilter} from "@michalrakus/x-react-web-lib/FindParam";
import {XUtilsCommon} from "@michalrakus/x-react-web-lib/XUtilsCommon";
import {XExpansionSwitch, XExpansionStateType} from "../zapisy/XExpansionSwitch";
import {useXStateSession} from "@michalrakus/x-react-web-lib/useXStateSession";
import {KlientSluzbaCielSpoluprace} from "../../model/klient/klient-sluzba-ciel-spoluprace.entity";
import {XUtils} from "@michalrakus/x-react-web-lib/XUtils";
import {KlientSluzba} from "../../model/klient/klient-sluzba.entity";

export const KlientSluzbaCielSpolupraceBrowse = (props: XBrowseProps & XSearchBrowseProps) => {

    const xLazyDataTableRef = useRef<XLazyDataTableRef>(null);

    const sluzbaEnum: SluzbaEnum | undefined = Utils.getCurrentSluzba()?.kod as SluzbaEnum;

    const expansionSwitchValueInit: XExpansionStateType = "colapsed";
    const [expansionSwitchValue, setExpansionSwitchValue] = useXStateSession<XExpansionStateType>(`klient-sluzba-ciel-spoluprace-browse-${sluzbaEnum}-expansion-switch-value`, expansionSwitchValueInit);

    useEffect(() => {
        xLazyDataTableRef.current?.setupExpandedRows();
    }, [expansionSwitchValue]);

    const showExpandedRow = (cielSpoluprace: KlientSluzbaCielSpoluprace, switchValue: XMultilineRenderType): boolean => {
        return expansionSwitchValue === "expanded" && cielSpoluprace.ciastkoveCiele !== null;
    };

    const rowExpansionTemplate = (cielSpoluprace: KlientSluzbaCielSpoluprace) => {
        return (
            <div className="x-multiline-content">
                {cielSpoluprace.ciastkoveCiele}
            </div>
        );
    };

    const rowClassName = (rowData: KlientSluzbaCielSpoluprace) => {
        return {
            'zapis-hlavny-riadok': expansionSwitchValue === 'expanded'
        };
    };

    // iba aktivnych klientov zobrazime a len zaznamy ktore nemaju vyplneny datumDo (neukoncene ciele)
    let customFilter: XCustomFilter | undefined = {where: `[klientSluzba.statusVSluzbe.code] = '${StatusVSluzbe.aktivnyKlient}' AND [datumDo] IS NULL`, params: {}};
    customFilter = XUtilsCommon.filterAnd(customFilter, {where: "[klientSluzba.sluzba] = :sluzbaId", params: {"sluzbaId": Utils.getCurrentSluzbaId() ?? 0}});

    return (
        <XLazyDataTable ref={xLazyDataTableRef} entity="KlientSluzbaCielSpoluprace" 
                        stateKey={`klient-sluzba-ciel-spoluprace-browse-${sluzbaEnum}`}
                        label="Ciele spolupráce" sortField="id" rows={30}
                        fields={["klientSluzba.klient.menoPriezviskoPrezyvka", "klientSluzba.klucovyPracovnikXUser.name"]}
                        customFilter={customFilter}
                        searchBrowseParams={props.searchBrowseParams}
                        rowClassName={rowClassName}
                        showExpandedRow={showExpandedRow}
                        rowExpansionTemplate={rowExpansionTemplate}
                        headerBodyRight={<XExpansionSwitch value={expansionSwitchValue} onChange={(switchValue: XExpansionStateType) => {setExpansionSwitchValue(switchValue);}} className="m-1"/>}>
            <XLazyColumn field="klientSluzba.klient.menoPriezviskoPrezyvka" header="Meno priezvisko prezývka" width="14rem" className="klient-meno"
                         filterElement={{element: (params: XFilterElementParams) => <KlientSluzbaColumnFilter filterParams={params} dropdownButtonEnabled={false}/>, matchModeLabel: xLocaleOption('xAutoComplete')}}/>
            <XLazyColumn field="klientSluzba.klucovyPracovnikXUser.name" header="Kľúčový pracovník" width="11rem"
                         autoComplete={Utils.userColumnAutoComplete("klientSluzba.klucovyPracovnikXUser")} autoFilter={true}/>
            <XLazyColumn field="datumOd" header="Dátum zač." width="8rem"/>
            <XLazyColumn field="ciel" header="Cieľ" contentType="multiline" width={expansionSwitchValue === "colapsed" ? "15rem" : `${(15 + 70)}rem`}/>
            {/*<XLazyColumn field="datumDo" header="Dátum koniec" width="8rem"/>*/}
            <XLazyColumn field="ciastkoveCiele" header="Čiastkové ciele" contentType="multiline" width="70rem"
                         columnViewStatus={expansionSwitchValue === "colapsed"}/>
        </XLazyDataTable>
    );
}

